import React, { useEffect, useState } from 'react';
import axios from "axios";
import './OrganizationsListView.css';

import { apiUrl } from '../../../utility/Connections';

import { Layout } from 'antd';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import TableOrganizations from '../../../components/tableOrganizations/tableOrganizations';
import Search from '../../../components/search/search';
import { useOutletContext } from 'react-router-dom';
const { Content } = Layout;

const OrganizationsListView = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [organizationsData, setOrganizationsData] = useState([]);
    const [filteredOrganizationsData, setFilteredOrganizationsData] = useState([]);
    const [searchText, setSearchText] = useState("");

    const { setOrganizationValuesToSee } = useOutletContext();

    useEffect(() => {
        getOrganizations()
    }, [])

    const getOrganizations = () => {
        setShowLoading(true);
        setLoadingText("Cargando organizaciones...")
        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .get(`${apiUrl}/organizations/get-organizations/`, headers)
            .then(function (response) {
                setOrganizationsData(response.data);
                setFilteredOrganizationsData(response.data);
                setShowLoading(false)
                setLoadingText(null)
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const onSearch = (value) => {
        setSearchText(value)
        filterData(value, organizationsData)
    }

    const filterData = (value, data) => {
        if (value.trim() === "") {
            setFilteredOrganizationsData(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.org_name.toLowerCase().includes(value.toLowerCase()) ||
                item.org_nit.toString().includes(value) || // NIT es numérico
                item.org_email.toLowerCase().includes(value.toLowerCase()) ||
                item.org_responsible_name.toLowerCase().includes(value.toLowerCase()) ||
                item.org_responsible_last_name.toLowerCase().includes(value.toLowerCase()) ||
                item.org_responsible_tel.toString().includes(value) || // Teléfono es numérico
                item.org_responsible_email.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredOrganizationsData(filtered);
        }
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer'>
            <div className='layout-content'>
                <Search onSearch={onSearch} />
                <br></br>
                <TableOrganizations setOrganizationValuesToSee={setOrganizationValuesToSee} data={filteredOrganizationsData} />
            </div>
        </Content>
    </div>
}

export default OrganizationsListView;